export default function log({ next }) {
  return next();
}



// WEBPACK FOOTER //
// ./src/middleware/log.js